/* Men's crew-socks PDP upsell — colour choice + one-tap add via the theme's cart API.

   Colours are separate products (radio swatches carry each one's variant id, price,
   compare-at and image). The store's active product-form build ignores the native `bundles`
   hook in its AJAX (drawer) path, so we add the selected sock ourselves: POST to /cart/add,
   then publish the theme's cartUpdate so the drawer/cart count refresh. We deliberately do
   NOT open the drawer — the shopper stays on the shoe; the button shows inline "Added". */
if (!customElements.get('sock-upsell')) {
  customElements.define(
    'sock-upsell',
    class SockUpsell extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-sock-add]');
        this.priceEl = this.querySelector('[data-sock-price]');
        this.compareEl = this.querySelector('[data-sock-compare]');
        this.imgEl = this.querySelector('[data-sock-img]');
        this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
        if (!this.button || this.radios.length === 0) return;
        this.radios.forEach((r) => r.addEventListener('change', () => this.onColour()));
        this.button.addEventListener('click', this.add.bind(this));
        this.sync();
      }

      get selected() {
        return this.radios.find((r) => r.checked) || this.radios[0];
      }

      // Reflect the chosen colour's price / compare-at / image.
      sync() {
        const r = this.selected;
        if (!r) return;
        if (this.priceEl) this.priceEl.textContent = r.dataset.price || '';
        if (this.compareEl) {
          const c = r.dataset.compare || '';
          this.compareEl.textContent = c;
          this.compareEl.hidden = !c;
        }
        if (this.imgEl && r.dataset.img) this.imgEl.src = r.dataset.img;
      }

      // Switching colour re-enables Add so the other colour can also be added.
      onColour() {
        this.removeAttribute('data-added');
        const txt = this.button.querySelector('.btn-text');
        if (txt) txt.textContent = 'Add';
        this.sync();
      }

      add() {
        if (this.busy || this.hasAttribute('data-added')) return;
        const variantId = this.selected && this.selected.value;
        if (!variantId) return;
        this.busy = true;
        this.button.setAttribute('aria-busy', 'true');

        let sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } })
        );

        const config = theme.utils.fetchConfig('javascript');
        config.headers['Content-Type'] = 'application/json';
        config.body = JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections,
          sections_url: window.location.pathname,
        });

        fetch(theme.routes.cart_add_url, config)
          .then((response) => response.json())
          .then(async (parsed) => {
            if (parsed.status) {
              console.error('[sock-upsell]', parsed.description);
              return;
            }
            const cart = await (
              await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
            ).json();
            cart.sections = parsed.sections;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sock-upsell', cart });

            this.setAttribute('data-added', '');
            const txt = this.button.querySelector('.btn-text');
            if (txt) txt.textContent = 'Added ✓';
          })
          .catch((error) => console.error('[sock-upsell]', error))
          .finally(() => {
            this.busy = false;
            this.button.removeAttribute('aria-busy');
          });
      }
    }
  );
}
